import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

import { cubicajeSchema } from '../../constants'

export const OperacionModificarCubicajeView = ({ silo: { altura, nombreCorto, ph, metrosDeVacio }, aceptar, cancelar }) => (
  <Formik initialValues={{ metrosDeVacio, ph }} onSubmit={aceptar} validationSchema={cubicajeSchema(altura)}>
    {({ isSubmitting, isValid }) => (
      <Form>
        <Grid container spacing={2} direction='column' justify='space-around'>
          <Grid item>
            <Typography variant='h6'>Modificar cubicaje de <strong>{nombreCorto}</strong></Typography>
          </Grid>
          <Grid container item spacing={2}>
            <Grid item xs={12} sm={6}>
              <Field component={TextField} name='metrosDeVacio' type='text' label='Metros de vacio' />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field component={TextField} name='ph' type='number' label='ph' />
            </Grid>
          </Grid>
          <Grid container item justify='space-between'>
            <Grid item xs='auto'>
              <Button
                variant='contained'
                color='secondary'
                disabled={isSubmitting}
                startIcon={<HighlightOffIcon />}
                onClick={cancelar}>
                Cancelar
              </Button>
            </Grid>
            <Grid item xs='auto'>
              <Button
                variant='contained'
                color='primary'
                disabled={isSubmitting || !isValid}
                startIcon={<CheckCircleOutlineIcon />}
                type='submit'>
                Aceptar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Form>
    )}
  </Formik>
)
